import { stateObj, actionObj } from "../const"

export default function reducer(state: stateObj, action: actionObj): stateObj {
    // console.log("%c!", "color:white;padding:.5em;background-color: gray;", state, action)
    switch (action.type) {
        case "set-lang":
            return { ...state, lang: action.payload }

            case "set-w" :
             return { ...state, w: action.payload }

             case "set-user" :
              return { ...state, ...action.payload }

        default:
            return state
    }
}